import { render, staticRenderFns } from "./GoalLinkList.vue?vue&type=template&id=79fd9b50"
import script from "./GoalLinkList.vue?vue&type=script&lang=js"
export * from "./GoalLinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports